
import { Link, useLocation } from 'react-router-dom';

export default function MobileBottomNav() {
  const location = useLocation();
  const currentPath = location.pathname;

  const navItems = [
  {
    path: '/',
    icon: 'ri-home-5-line',       // correct & common for Home
    activeIcon: 'ri-home-5-fill',
    label: 'Home'
  },
  {
    path: '/transactions',
    icon: 'ri-history-line',      // correct for History (clock arrow / timeline)
    activeIcon: 'ri-history-fill',
    label: 'History'
  },
  {
    path: '/rewards',
    icon: 'ri-gift-line',         // correct & popular for Rewards (gift box)
    activeIcon: 'ri-gift-fill',
    label: 'Rewards'
  },
  {
    path: '/account',
    icon: 'ri-user-3-line',       // correct for Profile/User (modern user avatar)
    activeIcon: 'ri-user-3-fill',
    label: 'Profile'
  },
];

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0   z-50 safe-area-bottom p-1">
      <div className="flex justify-around items-center h-16 px-2 bg-gray-100 rounded-full">
        {navItems.map((item) => {
          const isActive = currentPath === item.path;
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`flex flex-col items-center justify-center flex-1 py-2 cursor-pointer transition-colors ${
                isActive ? 'text-navy-600' : 'text-gray-500'
              }`}
            >
              <div className="w-6 h-6 flex items-center justify-center">
                <i className={`${isActive ? item.activeIcon : item.icon} text-xl`}></i>
              </div>
              <span className={`text-xs mt-1 mb-2 ${isActive ? 'font-medium' : ''}`}>{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
